import styled, { css } from 'styled-components'

type Props = {
  columnBreakpoint: number
}

const SidebarContainer = styled('div')`
  ${({ columnBreakpoint }: Props) => css`
    @media screen and (min-width: ${columnBreakpoint + 1}) {
      max-width: 320px;
    }
  `}
`

export default SidebarContainer
